import {
	BudgetChains,
	ConsumerEstimatesV2ResponseDto,
	V2BudgetData,
} from '#modules/Budget/types/budgetApi.types'

const mockConsumerEstimatesV2Response: ConsumerEstimatesV2ResponseDto = {
	disposableAmount: 5000,
	expenses: 15000,
	income: 0,

	incomeSalary: 5550,
	incomeBonusAndGross: 0,
	incomeSecondary: 0,
	incomeSupplementary: 0,

	expensesHousing: 6000,
	expensesHousingMortgageAndLoans: 2000,
	expensesHousingRent: 0,
	expensesHousingUtilities: 800,
	expensesHousingMaintenance: 300,
	expensesHousingOther: 400,

	expensesTransport: 2000,
	expensesTransportCarLoanAndLeasing: 600,
	expensesTransportCarOperatingCost: 700,
	expensesTransportCarMaintenanceCost: 300,
	expensesTransportPublic: 400,

	expensesLoans: 1500,
	expensesLoansOverdraft: 200,
	expensesLoansStudent: 300,
	expensesLoansConsumer: 200,
	expensesLoansDebtCollection: 100,
	expensesLoansCreditCardRepayments: 200,
	expensesLoansBankLoans: 200,
	expensesLoansPublicDebt: 100,
	expensesLoansUnidentified: 200,

	expensesOthers: 5500,
	expensesOthersInsurance: 5550,
	expensesOthersUnionFees: 300,
	expensesOthersPhoneAndBroadband: 400,
	expensesOthersChildrenInstitutions: 1000,
	expensesOthersMaintenanceAndChildSupport: 700,
	expensesOthersPrivatePension: 800,
	expensesOthersUncategorizedPaymentServices: 300,
	expensesOthersAdditionalFixed: 500,

	insights: {
		isRenting: true,
		isCooperativeHousing: false,
		isRentIncludedInExpensesOthersAdditionalFixed: false,
		isRentIncludedInExpensesOthersUncategorizedPaymentServices: false,
		isLeasingCar: false,
		hasPaymentsToAKasse: true,
		hasFreePhone: false,
	},
}

export const mockBudgetChains: BudgetChains = {
	incomeSalary: [],
	incomeBonusAndGross: [],
	incomeSecondary: [],
	incomeSupplementary: [],

	expensesHousingRent: [],
	expensesHousingUtilities: [],
	expensesHousingMaintenance: [],
	expensesHousingOther: [],

	expensesTransportCarOperatingCost: [],
	expensesTransportCarMaintenanceCost: [],
	expensesTransportPublic: [],

	expensesOthersInsurance: [],
	expensesOthersUnionFees: [],
	expensesOthersPhoneAndBroadband: [],
	expensesOthersChildrenInstitutions: [],
	expensesOthersMaintenanceAndChildSupport: [],
	expensesOthersAdditionalFixed: [],
	expensesOthersPrivatePension: [],
	expensesOthersUncategorizedPaymentServices: [],

	expensesHousingMortgageAndLoans: [],
	expensesTransportCarLoan: [],
	expensesTransportCarLeasing: [],

	expensesLoansOverdraft: [],
	expensesLoansStudent: [],
	expensesLoansConsumer: [],
	expensesLoansUnidentified: [],
	expensesLoansDebtCollection: [],
	expensesLoansCreditCardRepayments: [],
	expensesLoansUnsecuredBankLoans: [],
	expensesLoansHomeLoans: [],
	expensesLoansPublicDebt: [],
}

export const budgetMock: V2BudgetData = {
	estimates: mockConsumerEstimatesV2Response,
	userCorrected: mockConsumerEstimatesV2Response,
	budgetCategorizedTransactions: {
		budgetCategories: [],
	},
	budgetChains: mockBudgetChains,
}
